module.exports = __webpack_public_path__ + "img/frete-gratis.485951f1.png";